import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { landscapeUrl: String, portraitUrl: String };

  connect() {
    this.lazyLoad();
  }

  disconnect() {
    if (this.iframe) {
      this.iframe.remove();
    }
  }

  lazyLoad() {
    if (this.element.querySelector('iframe')) {
      return;
    }
    const isLandscape = window.innerWidth > 768;
    const url = isLandscape ? this.landscapeUrlValue : this.portraitUrlValue;

    this.iframe = document.createElement("iframe")
    this.iframe.setAttribute('class', 'w-full h-[56.25vw] min-h-[100vh] min-w-[177.77vh]');

    this.iframe.setAttribute('frameborder', '0');
    this.iframe.setAttribute('allow', 'autoplay; picture-in-picture');
    this.iframe.setAttribute('allowfullscreen', '');
    this.iframe.setAttribute('allowfullscreen', 'allowfullscreen');
    this.iframe.setAttribute('mozallowfullscreen', 'mozallowfullscreen');
    this.iframe.setAttribute('msallowfullscreen', 'msallowfullscreen');
    this.iframe.setAttribute('oallowfullscreen', 'oallowfullscreen');
    this.iframe.setAttribute('webkitallowfullscreen', 'webkitallowfullscreen');
    this.iframe.setAttribute('preload', 'auto');

    this.iframe.setAttribute("src", url);
    this.element.appendChild(this.iframe);
  }
}
